import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '~/javascript/components/gbp_campaigns/index.vue'

export default class extends Controller {
  static values = {
    locationId: String,
    defaultKeywords: Array
  }

  connect() {
    this.vue = createApp(App, {
      locationId: this.locationIdValue,
      defaultKeywords: this.defaultKeywordsValue
    })
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
